'use strict';
(function () {
  var _controller = 'storeProductFilter.controller';
  angular.module('pentaApp').controller(_controller, controller);
  controller.$inject = ['$scope', 'image.resource'];
  function controller($scope, imageResource) {
    /// Methods
    $scope.filterView = filterView;
    $scope.selectProduct = selectProduct;
    $scope.imageResource = imageResource;

    /// Vars
    $scope.categories = appNavigator.topPage.data.categories;
    $scope.parentCategory = appNavigator.topPage.data.parentCategory;
    $scope.selectProductFunction = appNavigator.topPage.data.selectProductFunction;
    var products = appNavigator.topPage.data.products;
    var popPageCallback = appNavigator.topPage.data.popPageCallback;

    /// Esto se hace para poder hacer un ng-repeat que crea un scope nuevo 
    //  y que permite usar las plantillas de categorías. Es un truco
    $scope.openedCategories = [{
      products: products,
      viewType: $scope.parentCategory && $scope.parentCategory.subViewType || 'VERTICAL-LIST',
      name: $scope.parentCategory ? '' : i18next.t('Resultados')
    }]
    
    if($scope.parentCategory && $scope.parentCategory.filterViewType)
      $scope.openedCategories[0].filterViewType = $scope.parentCategory.filterViewType;


    /// Watchers

    /// Init
    init()
    
    setTimeout(function(){
      document.getElementById('filterProductsInput').focus();
    }, 500)

    ////////////////////////

    function init(){
      $scope.toSearchProducts = products;
      if($scope.categories) iterateCategories($scope.categories);
      function iterateCategories(categories){
        categories.forEach(function(category){
          if(category.products && category.products.length)
            $scope.toSearchProducts = $scope.toSearchProducts.concat(category.products)
          if(category.categories) iterateCategories(category.categories)
        })
      }
    }

    function selectProduct(product){
      // Ver función selectProduct de productSelectionController
      // si devuelve false vuelvo hacia atrás porque es probable de que se haya abierto un popup
      if($scope.selectProductFunction) 
        if(!$scope.selectProductFunction(product)){
          recursivePopPage();
        }
    }

    function recursivePopPage(){
      window.appNavigator.popPage({
        callback: popPageCallback
      });
    }

    function filterView(categories, products, parentCategory){
      if((!categories || !categories.length) && (!products || !products.length)) return;
      window.appNavigator.pushPage('store/storeProductFilter/storeProductFilter.jade', { 
        data: { 
          categories: categories, 
          parentCategory: parentCategory, 
          products: products, 
          selectProductFunction: $scope.selectProductFunction, 
          onClose: Function.Prototype,
          popPageCallback: recursivePopPage
        } 
      });
    }

  }
})();
